/**
 * Disables scrollRestoration
 */
export const disableScrollRestoration = () => {
    if ('scrollRestoration' in history) {
        // CO-19261: Don't restore scroll position on browser navigation
        history.scrollRestoration = 'manual';
    }
};
